import { MutableRefObject, useEffect } from 'react';

function useOnClickOutside<T extends Element>(
  contentRef: MutableRefObject<T | null> | MutableRefObject<T | null>[] | null,
  handler: (event?: MouseEvent | TouchEvent) => void,
  listenerElement?: MutableRefObject<T | null> | null,
  hookDependencies: unknown[] = [],
) {
  useEffect(() => {
    if (!contentRef) {
      return;
    }
    const outsideElement = listenerElement?.current || document;

    const listener = ((event: MouseEvent | TouchEvent) => {
      const source = Array.isArray(contentRef) ? contentRef : [contentRef];
      const clickedWithinContent = source.some(({ current }) => {
        if (!(event.target instanceof Element)) {
          return false;
        }

        if (current?.contains(event.target)) {
          return true;
        }

        return false;
      });

      if (clickedWithinContent) {
        return;
      }

      handler(event);
    }) as EventListenerOrEventListenerObject;

    outsideElement.addEventListener('mousedown', listener);
    outsideElement.addEventListener('touchstart', listener);

    return () => {
      outsideElement.removeEventListener('mousedown', listener);
      outsideElement.removeEventListener('touchstart', listener);
    };
  }, hookDependencies);
}

export default useOnClickOutside;
